import { AttendingEventType } from "store/attendingEvents/attendingEvents.types";

export enum USER_TYPE {
  ORGANIZATION="organization",
  MYSELF="myself",
  VOLUNTEER="volunteer",
  UNDEFINED="undefined"
}

export interface User {
  id: number;
  name: string;
  email: string;
  phone_number: string;
  stripe_customer_id: string;
  socialAvatarUrl?: string;
  facebookUrl?: string;
  instagram_handle?: string;
  benevv_handle?: string;
  remember_token?: string;
  user_type: string;
  user_find_score: number;
  language_type?: string;
  bio_description?: string;
  push_notification_token?: string;
  alerts_selected: number;
  alerts_activity_attend: number;
  alerts_activity_cancel: number;
  alerts_activity_other: number;
  alerts_idol_latest: number;
  alerts_follower_added: number;
  alerts_follow_other: number;
  created_at: string;
  updated_at: string;
  deleted_at?: string;
  banner_image_url: null | string; // set image url
  blocked: {
    blocked?: number[];
    blocked_by?: number[];
  };
  templateType: string;
  templateModel: {
    id: number;
    user_id: number;
    myself_type?: string;
    myself_gender_type?: string;
    myself_age_range_type?: string;
    myself_birth_year?: string;
    myself_birth_month_and_day?: string;
    created_at?: string;
    updated_at?: string;
    industry?: string;
  };
  location: null | string;
  reset_expiration: null | string;
  reset_key: null | string;
  skills?: any[];
}

export interface Project {
  id: number;
  program_id?: number;
  project_name?: string;
  project_description?: string;
  start_date_time?: Date;
  end_date_time?: Date;
  location?: string;
  total_goal: number | undefined;
  total_raised: number | undefined;
  created_at?: Date;
  updated_at?: Date;
  deleted_at?: null;
}

export interface ProjectData {
  project_name: string;
  project_description: string;
  program_id: number | null;
  start_date_time: string;
  end_date_time: string;
  location: string;
  causeIds: number[];
  activityIds: number[];
  postIds: number[];
}

export interface CampaignInfo {
  awards: string | null;
  count_donor: number;
  created_at: string;
  default_image: string;
  description: string;
  end_date_time: string;
  goal: number;
  id: string;
  location: string;
  name: string;
  project_id: number;
  short_id: string;
  shortened_location: string;
  start_date_time: string;
  status: string;
  total_raised: number;
  updated_at: string;
  user_id: number;
}

export interface ProjectDetails {
  id: number;
  program_id: Program["id"] | null;
  activities: Event[];
  campaigns: CampaignInfo[];
  posts: Post[];
  causes: Cause[];
  project_description: string;
  project_name: string;
  start_date_time: string;
  end_date_time: string;
  location: string;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  user_id: number;
}

export interface Cause {
  id: number;
  parent_id: number;
  cause_name: string;
  cause_description: string;
  cause_image: string;
  created_at: string;
  updated_at: string;
}

export type CauseId = Cause["id"];

export interface CreatePostData {
  post_caption: string;
  post_image: string;
  campaing_short?: string;
  reporterId?: string;
  status?: string;
  post_location: string[];
  causeIds: CauseId[];
  activityIds?: number[];
  project_id?: Project["id"];
}

export interface PaginationProps {
  current_page: number;
  total_pages: number;
}

export interface IEventData {
  activity: {
    id: number;
    is_private: number | null;
    activity_title: string;
    activity_description: string | null;
    activity_goal: string | null;
    condition_type: string;
    activity_url: string | null;
    start_date_time: string;
    end_date_time: string;
  };
  visuals: Array<{
    id: number;
    activity_id: number;
    image_url: string;
    created_at: string;
    updated_at: string;
  }>;
  places: Array<{
    id: number;
    place_city: string;
    place_country: string;
    place_state: string;
    place_postcode: string;
    place_details: string;
  }>;
  users: Array<{
    user_id: number;
    name: string;
    socialAvatarUrl: string;
    user_type: string;
    template_type: string;
    part_type: string;
    status_type: AttendingEventType;
  }>;
  pursuits: Array<{
    id: number;
    cause_name: string;
    cause_description: string;
    cause_image: string;
  }>;
}

export interface CreateEventData {
  id?: number;
  activity_title: string;
  start_date_time: string;
  end_date_time?: string;
  Event_image: string;
  activity_description: string;
  activity_goal: string;
  Country: string;
  City: string;
  State: string;
  Postcode: string;
  Details: string;
  GoogleUrl: string;
  influencerIds: number[];
  brandIds: number[];
  volunteerIds: number[];
  nonProfitIds: number[];
  inviteIds: number[];
  causeIds: number[];
  postIds: number[];
  is_private: number;
}

export interface Program {
  //updated to have the different values of returned data from API
  id: number;
  program_name: string;
  program_description: string;
  created_at: string;
  updated_at: string;
  deleted_at?: string;
  projects: any[];
}

export interface Organization {
  org_owner?: string;
  org_name: string;
  org_email: string;
  org_creation_token: string;
  org_instagram_handle: string;
  org_facebook_profile: string;
  org_image: string;
  org_type: string;
  org_industry: string;
  org_size: string;
  org_city: number;
  org_legal_name: string;
  org_registration_status: string;
  org_registration_number: string;
  org_geographic_area: string;
  org_ein: string;
  org_dnb_number: string;
  org_location: string; // ej. '["City","State","Country"]'
  org_foundation_date: string; // formato YYYY-MM-DD
  org_naics_code: string;
  org_ntee_code: string;
  org_description: string;
  org_utility_bill: string;
  org_certification_of_formation: string;
  org_determination_letter: string;
  org_business_licenses: string;
  org_tax_returns: string;
}
export interface userOrganization {
  organization_id: number;
  name: string;
  socialAvatarUrl?: string;
}

export interface Donor {
  id: string;
  user_id: number;
  campaign_id: string;
  action_id: number;
  action_type: string;
  amount: string;
  anon: number;
  created_at: string;
  display_donation: number;
  note: string;
  status: string;
  temp_campaign_id: string;
  updated_at: string;
  user: Pick<
    User,
    | "id"
    | "name"
    | "banner_image_url"
    | "location"
    | "reset_expiration"
    | "reset_key"
    | "socialAvatarUrl"
    | "user_type"
  >;
}

export interface ProcessedCampaignInfo {
  user_id: User["id"];
  name: string;
  fundraiserId: string;
  daysLeft: number;
  totalAmounts: number;
  currentAmounts: number;
  totalDonors: number;
}

export interface LeaderDonor {
  id: number;
  name: string;
  avatar: string;
  amount: number;
  date: string;
  anon: number;
  display_donation: number;
}
